import React from "react";
import { Helmet } from "react-helmet";
import Ctapage from "../../Components/internal-pages/Cta_Section";
import NoGapContentpoints from "../../Components/sub-pages/NoGapContent_point";

const Officesupplies =()=>{
    const CTAContent = [
        {
          pageName: "Office Supplies",
          paragraphitalic: "Streamline Essentials with Ease",
          paragraphText:
                "Keep your workplace running smoothly with a dedicated store for all your office supply needs. Whether it’s day-to-day essentials or branded stationery, we provide a one-stop solution to make sure your team always has what they need.",
          ContactFormName: "Office Supplies",
        },
      ];
    
      const ListContent=[
        {
            Heading:[
                {
                    ListHeading:"Custom-Branded Stationery",
                },
                {
                    ListHeading:"Tech Accessories & Gadgets",
                },
                {
                    ListHeading:"Employee Onboarding Kits",
                }
            ],
            RightImgNogap:"../assests/images/company-store/Office supplies_inside.png"
        }
      ]
      
    
  return (
    <>
      <Helmet>
        <title>eYantra Company Store & Corporate Gifts</title>
        <meta name="description" content="eYantra offers office supplies, branded merchandise, joining kits, and welcome kits through its company store with premium corporate gifts in Hyderabad."/>
        <meta name="keywords" content="eyantra, company store, office supplies, branded merchandise, corporate gifting, joining kits,  corporate gifts, corporate gifts for employees, welcome kits,corporate gifts in hyderabad, branded corporate,"/>
      </Helmet>
      <div className="p-0 m-2">
      <Ctapage data={CTAContent} />
      <NoGapContentpoints data={ListContent[0]}/>
      </div>
      

      <p className="text-center fs-32 w-75 d-block m-auto py-5">
        We curate stores that make managing inventory simple while guaranteeing that your workplace essentials reflect your company’s professional image.
      </p>
    </>
  );
};

export default Officesupplies;